import React from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const Navigation = ({
  scrollToFAQ,
  scrollToPricing,
  scrollToServices,
  scrollToCallCard,
  hideNavLinks, // New prop
}) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Navbar className="body-font" bg="white" expand="lg" sticky="top">
      <Container className="">
        <Navbar.Brand
          className="purple-color righteousy-font"
          as={Link}
          to="/"
          onClick={scrollToTop} // Added onClick handler
        >
          <span className="fs-four-title">Nouraa</span>
          <span className="fs-three">.ai</span>
        </Navbar.Brand>
        {!hideNavLinks && ( // Conditionally render navigation links
          <>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              className="border-dark"
            />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto nav-link-mt">
                <Nav.Link
                  className="gray-color  fw-bold px-lg-4"
                  onClick={scrollToPricing}
                >
                  Pricing
                </Nav.Link>
                <Nav.Link
                  className="gray-color  fw-bold px-lg-4"
                  onClick={scrollToCallCard}
                >
                  Analytics
                </Nav.Link>
                <Nav.Link
                  className="purple-color fw-bold px-lg-4 position-relative" // Highlight and position badge
                  href="https://www.royalcyber.com/webinar/ai-powered-patient-communication/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Webinar
                  <span
                    className="badge bg-danger text-white position-absolute top-0 start-100 translate-middle d-none d-lg-inline" // Hide on mobile devices
                    style={{
                      fontSize: "0.75rem",
                      padding: "0.2em 0.4em",
                      borderRadius: "0.5rem",
                    }}
                  >
                    Upcoming
                  </span>
                </Nav.Link>
                <Nav.Link
                  className="gray-color fw-bold px-lg-4 ms-lg-4"
                  onClick={scrollToServices}
                >
                  Services
                </Nav.Link>

                <Nav.Link
                  className="gray-color  fw-bold px-lg-4"
                  onClick={scrollToFAQ}
                >
                  FAQs
                </Nav.Link>
              </Nav>
              <Nav>
                <Button
                  variant="none"
                  as={Link}
                  to="/login"
                  className="me-4 gray-color fw-bold"
                >
                  Log in
                </Button>
                <Button
                  className="btn-primary-style fw-bold"
                  as={Link}
                  to="/signup"
                >
                  Get Started for Free
                  <img
                    className="ms-2"
                    src="/assets/arrow-right-white.svg"
                    alt="Play"
                  />
                </Button>
              </Nav>
            </Navbar.Collapse>
          </>
        )}
      </Container>
    </Navbar>
  );
};

export default Navigation;
